
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"92","height":"112","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"opacity":".6","width":"92","height":"112","rx":"4","fill":"#E8EBF1"}}),_c('path',{attrs:{"opacity":".4","fill":"#9AA5BB","fill-opacity":".75","d":"M10 84h68v4H10zM10 92h40v4H10z"}}),_c('path',{attrs:{"opacity":".5","d":"M42.887 55.584c-.992-1.088-1.488-2.544-1.488-4.368 0-1.152 1.024-2.544 3.072-4.176 1.248-.992 2.128-1.728 2.64-2.208.544-.48.976-.992 1.296-1.536.32-.576.48-1.216.48-1.92 0-1.888-1.36-2.832-4.08-2.832-1.888 0-4.192.256-6.912.768l-.336-4.848a23.19 23.19 0 018.736-1.68c6.176 0 9.264 2.496 9.264 7.488 0 1.728-.112 3.088-.336 4.08a6.296 6.296 0 01-1.104 2.544c-.512.704-1.328 1.472-2.448 2.304-1.344.992-2.288 1.84-2.832 2.544-.544.672-.816 1.456-.816 2.352v1.488h-5.136zm-1.056 2.688h6.912V66h-6.912v-7.728z","fill":"#9AA5BB","fill-opacity":".75"}})])
          )
        }
      }
    